import type { Dispatch, SetStateAction } from "react";
import Modal from "react-modal";
import ModalStyle from "Assets/ModalStyle";
import { usePlantStore } from "Store/PlantStore";

type Props = {
    plantId?: string;
    setShowDeleteModal: Dispatch<SetStateAction<boolean>>;
    showDeleteModal: boolean;
};

const DeletePlantModal: React.FC<Props> = ({ setShowDeleteModal, plantId, showDeleteModal }) => {
    const deletePlant = usePlantStore((state) => state.deletePlant);

    return (
        <Modal style={ModalStyle.defaultStyle} ariaHideApp={false} isOpen={!!plantId && showDeleteModal}>
            <div className="m-50 p-5 grid grid-cols-1 grid-rows-3 h-full w-full text-center">
                <h3 className="text-lg py-5">Delete Plant</h3>
                <p>Are you sure you want to delete this plant?</p>
                <div className="grid grid-cols-3 pt-10 w-full">
                    <div></div>
                    <div className="flex">
                        <button onClick={() => setShowDeleteModal(false)} className="btn bg-gray-light mr-5 flex-grow h-10">
                            Cancel
                        </button>
                        <button
                            onClick={async () => {
                                if (!plantId) {
                                    return;
                                }

                                await deletePlant(plantId);
                                setShowDeleteModal(false);
                            }}
                            className="btn btn-danger flex-grow h-10"
                        >
                            Delete
                        </button>
                    </div>
                    <div></div>
                </div>
            </div>
        </Modal>
    );
};

export default DeletePlantModal;